import type { ReactNode } from "react";
import { Search } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import {
  DataTableColumnSettings,
  DataTableProvider,
  type TableColumnDef,
} from "../data-table";

export interface ListMasterPageLayoutProps<T> {
  tableId: string;
  tableColumns: TableColumnDef<T>[];
  listTitle: string;
  searchPlaceholder: string;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  headerActions: ReactNode;
  children: ReactNode;
  /** When false, hides the search input */
  showSearch?: boolean;
}

export function ListMasterPageLayout<T>({
  tableId,
  tableColumns,
  listTitle,
  searchPlaceholder,
  searchTerm,
  onSearchChange,
  headerActions,
  children,
  showSearch = true,
}: ListMasterPageLayoutProps<T>) {
  return (
    <DataTableProvider tableId={tableId} columns={tableColumns}>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 py-3">
          <CardTitle>{listTitle}</CardTitle>
          <div className="flex items-center gap-2">
            {headerActions}
            <DataTableColumnSettings columns={tableColumns} />
          </div>
        </CardHeader>
        <CardContent className="space-y-3 p-3 pt-0">
          {showSearch && (
            <div className="relative w-full md:max-w-sm">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input
                placeholder={searchPlaceholder}
                value={searchTerm}
                onChange={e => onSearchChange(e.target.value)}
                className="pl-10"
              />
            </div>
          )}
          {children}
        </CardContent>
      </Card>
    </DataTableProvider>
  );
}
